import React from "react";
// import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

//MUI
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import { FaTrash } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { Button } from "@mui/material";
// import { setFileName } from "../../features/datatable/dataTableSlice";

// import { apiUrl } from "../../utils/variables";

const actionStyle = {
  position: "absolute",
  top: "30px",
  right: "20px",
  color: "#cccccc",
  cursor: "pointer",
};

const FileCard = ({
  fileId,
  fileName,
  editDate,
  fileSize,
  createdBy,
  isDeleted = false,
  action,
}) => {
  // const token = useSelector((state) => state.auth.token);
  // const dispatch = useDispatch();
  const theme = useTheme();

  const handleNameDisplay = () => {
    if (isDeleted) {
      return fileName;
    }

    return <Link to={`/file/${fileId}`}>{fileName}</Link>;
  };

  const handleActionDisplay = () => {
    if (isDeleted) {
      // return null;
      return (
        <Button
          variant="contained"
          sx={{
            width: "auto",
            padding: "0 10px",
            position: "absolute",
            top: "20px",
            right: "20px",
            boxShadow: "none",
          }}
          onClick={() => {
            action(fileId);
          }}
        >
          Restore File
        </Button>
      );
    }

    return (
      <IconContext.Provider
        value={{
          style: actionStyle,
        }}
      >
        <FaTrash
          onClick={() => {
            action(fileId);
          }}
        />
      </IconContext.Provider>
    );
  };

  return (
    <Box
      sx={{
        marginRight: "20px",
        marginBottom: "20px",
        fontWeight: "500",
        fontSize: "18px",
        width: "290px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "20px 20px 0 0",
          position: "relative",
          minHeight: "120px",
        }}
      >
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: "600",
            textOverflow: "ellipsis",
            lineHeight: "1.1",
            marginBottom: "5px",
            minHeight: "4rem",
            maxWidth: "230px",
          }}
        >
          {handleNameDisplay()}
        </Typography>
        <p>Edited last {dayjs(editDate).format("MMM DD, YYYY")}</p>
        <p>{fileSize}</p>
        {handleActionDisplay()}
      </Box>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.light,
          padding: "10px 20px 20px",
          borderRadius: "0 0 20px 20px",
          minHeight: "70px",
        }}
      >
        <p>Created by: {createdBy}</p>
      </Box>
    </Box>
  );
};

export default FileCard;
